import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { IconChevronRight } from '@noths/polaris-client-ribbons-design-system';
import dynamic from 'next/dynamic';

import { DELIVERY_DRAWER_URL_FRAGMENT_ID } from 'src/fragmentIDs';
import { DeliveryBlockContainer } from '../../containers/DeliveryBlockContainer/DeliveryBlockContainer';
import * as styles from './DeliverySection.styles';

const DeliveryAndReturnsDrawer = dynamic(() =>
  import(
    /* webpackChunkName: "delivery_returns_drawer" */ '../DeliveryAndReturnsDrawer/DeliveryAndReturnsDrawer'
  ).then((mod) => mod.DeliveryAndReturnsDrawer),
);

export interface DeliverySectionProps {
  onDetailsLinkClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  onVisible: () => void;
}

export const DeliverySection = ({ onDetailsLinkClick, onVisible }: DeliverySectionProps) => {
  const deliverySectionRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  return (
    <div ref={deliverySectionRef}>
      <DeliveryBlockContainer />
      <a
        css={styles.drawerLink}
        href={`#${DELIVERY_DRAWER_URL_FRAGMENT_ID}`}
        onClick={onDetailsLinkClick}
      >
        Returns details <IconChevronRight color="var(--brand-purple-base)" height={16} width={16} />
      </a>
      <DeliveryAndReturnsDrawer target={deliverySectionRef} />
    </div>
  );
};
